import { render, staticRenderFns } from "./study-achievement.vue?vue&type=template&id=04f09527&scoped=true"
import script from "./study-achievement.vue?vue&type=script&lang=js"
export * from "./study-achievement.vue?vue&type=script&lang=js"
import style0 from "./study-achievement.vue?vue&type=style&index=0&id=04f09527&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f09527",
  null
  
)

export default component.exports